module.exports = __webpack_public_path__ + "static/media/3.8f8e9554.png";